import { ICalendarLesson } from "../../../entities/calendar";
import { formatMoscowDate, formatMoscowTime } from "../../../shared/lib/helpers/moscowDateTime";

export interface ILessonTransferLabel {
    text: string;
    isMovedFrom: boolean;
}

export const getLessonTransferLabel = (lesson: ICalendarLesson): ILessonTransferLabel | null => {
    const isMovedTo = Boolean(lesson.movedTo)
    const link = isMovedTo ? lesson.movedTo : lesson.movedFrom
    if(!link?.startsAt) return null

    const isMovedFrom = !isMovedTo
    const prefix = isMovedFrom ? 'Перенесено с' : 'Перенесено на'
    const date = formatMoscowDate(link.startsAt, {day: '2-digit', month: '2-digit'})
    const time = formatMoscowTime(link.startsAt)

    return {
        text: `${prefix} ${date} ${time}`,
        isMovedFrom,
    }
}
